import { z } from 'zod';

export const stageItemStateSchema = z.object({
  status: z.enum(['OK', 'NG', 'NA']),
  defectType: z.string(),
  remark: z.string(),
});

export const stageStateSchema = z.object({
  dateTime: z.string(),
  inspectorFure: z.string(),
  actionStatus: z.string(),
  saved: z.boolean(),
  savedAt: z.string().nullable(),
  savedBy: z.string().nullable(),
  items: z.record(z.string(), stageItemStateSchema),
});

export const metadataSchema = z.object({
  container_origins: z.string(),
  container_origins_other: z.string(),
  inside_container: z.string(),
  inside_container_other: z.string(),
  model: z.string(),
  model_other: z.string(),
  invoice_no: z.string(),
  case_no: z.string(),
  box_no: z.string(),
  body_number: z.string().min(1, 'Body number is required'),
});

export const saveRecordSchema = z.object({
  metadata: metadataSchema,
  stages: z.record(z.coerce.number(), stageStateSchema),
});

export const loginSchema = z.object({
  pin: z.string().min(4).max(6),
});

export const registerInspectorSchema = z.object({
  pin: z.string().min(4).max(6),
  display_name: z.string().min(1),
});

export const invoiceMappingSchema = z.object({
  invoiceNo: z.string(),
  bodies: z.array(z.string()),
});

export const invoiceMappingsSchema = z.array(invoiceMappingSchema);

export const standaloneChoicesSchema = z.object({
  cases: z.array(z.string()),
  boxes: z.array(z.string()),
});

export const recordIdParamSchema = z.object({
  id: z.string().min(1),
});

export type SaveRecordInput = z.infer<typeof saveRecordSchema>;
export type LoginInput = z.infer<typeof loginSchema>;
export type RegisterInspectorInput = z.infer<typeof registerInspectorSchema>;
